<script>
	import { onMount } from 'svelte'

	let cy_ready = false
	onMount(async () => {
		cy_ready = true
	})
</script>

<slot />

{#if cy_ready}
	<div class="hidden cy_ready" />
{/if}
